<template>
    <div>
    <back-btn />
    <v-card>
      <v-card-text>
        <h2>Enroll Patients Export</h2>
        <v-row>
          <!-- <v-col lg="4">
            <label>Township Group</label>
            <v-select
              v-model="township_group_id"
              outlined
              dense
              item-text="name"
              item-value="id"
              :items="townshipGroups"
            ></v-select>
          </v-col> -->
          <v-col lg="4">
            <label>Month <require-sign /></label>
                  <v-select
                    class="mr-1"
                    :items="export_months"
                    v-model="month"
                    item-text="text"
                    :error-messages="monthValidation"
                    item-value="value"
                    dense
                    outlined
                  ></v-select>
          </v-col>
          <v-col lg="4">
            <label>Year <require-sign /></label>
                <v-select
                class="mr-1"
                :items="years"
                v-model="year"
                item-text="text"
                item-value="value"
                :error-messages="yearValidation"
                dense
                outlined
                ></v-select>
          </v-col>
           <v-col lg="4">
            <label>Type <require-sign /></label>
            <v-select
              v-model="type"
              outlined
              dense
              item-text="text"
              item-value="value"
              :items="types"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="form-btn" @click="exportData">
          <v-icon left>mdi-chevron-right-circle-outline</v-icon>Export
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import { ValidationMixin } from "./../../mixins/ValidationMixin";
  import BackBtn from "@/components/navigation/BackBtn.vue";
  import { required } from "vuelidate/lib/validators";
  import RequireSign from "@/components/notification/RequireSign.vue";
  
  export default {
    components: { BackBtn,RequireSign },
    mixins: [ValidationMixin],
    data: () => ({
        month: new Date().getMonth() + 1,
        year: 2025,
        township_group_id: null,
        type: "1",
        types: [
          { text: "Enroll", value: "1" },
          { text: "Pre-Enroll", value: "2" },
        ],
    }),
    validations: {
    month: {
      required,
    },
    year: {
      required,
    },
    types: {
      required,
    },
  },
  computed: {
    ...mapState("InitialData", ["export_months", "years"]),
    ...mapState("Admin", ["admin"]),
    monthValidation() {
      return this.handleFieldErrors(this.$v.month);
    },
    yearValidation() {
      return this.handleFieldErrors(this.$v.year);
    },
  },
    methods: {
        exportData() {
        if (this.$v.$invalid) {
            this.$toast.error("Please fill in all required fields.", { timeout: 2000 });
            return;
        }

        const data = {
            month: this.month,
            year: this.year,
            type: this.type,
        };

        if (this.admin && this.admin.township_group_id) {
            data.township_group_id = this.admin.township_group_id;
        }

        this.$store
            .dispatch("Patient/getEnrollExport", data)
            .then(() => {
            this.$toast.success("Export successful!", { timeout: 2000 });
            })
            .catch((error) => {
            this.$toast.error("Export failed. Please try again.", { timeout: 2000 });
            console.error(error);
            });
        },
    },
    created() {
      this.$store.dispatch("TownshipGroup/getTownshipGroups");
    },
  };
  </script>
  
  <style scoped></style>
  